<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-12">
      <div class="report-list-header margin-bottom">
        <h2 class="title">{{ 'performance_transactions.title' | translate }}</h2>
        <button routerLink="/reports/dashboard" class="ui-button secondary fit-width" (click)="track('[Button] Transacitons - Back')">
          {{ 'general.back' | translate }}
        </button>
      </div>
      <div class="fee-percentage" *ngIf="customer.email">
        {{ currentAccountDetail.inyova_fee | translatePercent: customer.language }}
        {{ (currentAccountDetail.kind === '3a' ? 'performance_fees.info.3a.annualFee' : 'performance_fees.info.fees') | translate }}
      </div>
      <div class="transactions-list white-box" *ngIf="transactions.length">
        <app-deposit-delay-info></app-deposit-delay-info>
        <div class="transactions-list-header">
          <p>{{ 'performance.columns.transfer' | translate }}</p>
          <p>{{ 'performance.columns.amount' | translate }} ({{ currentAccountDetail.currency }})</p>
        </div>
        <div *ngFor="let item of transactions | slice: startIndex:endIndex" class="transactions-list-item">
          <div class="transactions-list-item-left">
            <span>{{ item.type | translate }}</span>
            <span>{{ item.date }}</span>
          </div>
          <div class="transactions-list-item-right">{{ item.amount }}</div>
        </div>
      </div>
      <app-pagination
        *ngIf="transactions.length && pages > 1"
        [currentPage]="currentPage"
        [pages]="pages"
        [pagesSelectionOptions]="pagesSelectionOptions"
        (update)="updatePagination($event)"
      ></app-pagination>
    </div>
  </div>
</div>
